module.exports = __webpack_public_path__ + "img/favicon.dba0462c.png";